import './StaffSettingsView.css'

import { Link } from 'react-router'
import { useAtomValue } from 'jotai'

import { staff } from '../../../store'

import { PageHeader } from '../../../components/PageHeader'
import { Tag } from '../../../components/Tag'

type SettingsSection = {
  id: string
  title: string
  description: string
  permission?: string
}

const settingsSections: SettingsSection[] = [
  {
    id: 'regions',
    title: 'Regions',
    description: 'Enable regions, force-activate, and inspect waitlist pressure.',
    permission: staff.Permission.SettingsRegionsRead,
  },
  {
    id: 'waitlist',
    title: 'Waitlist',
    description: 'Inspect pending and notified entries; mark notified for ops.',
    permission: staff.Permission.SettingsWaitlistRead,
  },
  {
    id: 'staff',
    title: 'Staff & roles',
    description: 'Manage staff accounts and permission roles.',
    permission: staff.Permission.SettingsStaffRead,
  },
  {
    id: 'account',
    title: 'Your account',
    description: 'Change your staff password.',
  },
]

export function StaffSettingsView() {
  const session = useAtomValue(staff.staffSessionAtom)

  return (
    <div className="staff-settings">
      <PageHeader title="Settings" subtitle="System configuration for running Revel Club." />

      <ul className="staff-settings__list">
        {settingsSections.map((section) => {
          const allowed =
            !section.permission || staff.hasStaffPermission(session, section.permission)

          return (
            <li key={section.id} className="staff-settings__item">
              {allowed ? (
                <Link to={`/staff/settings/${section.id}`} className="staff-settings__card">
                  <span className="staff-settings__card-title">{section.title}</span>
                  <span className="staff-settings__card-description">{section.description}</span>
                </Link>
              ) : (
                <div className="staff-settings__card staff-settings__card--soon">
                  <div className="staff-settings__card-heading">
                    <span className="staff-settings__card-title">{section.title}</span>
                    <Tag color="amber">No access</Tag>
                  </div>
                  <span className="staff-settings__card-description">{section.description}</span>
                </div>
              )}
            </li>
          )
        })}
      </ul>
    </div>
  )
}
